/**
 * @module lib/audience/datalayer/article
 */
import tgamConfig from "config/tgam";
import trim from "lodash/trim";
import { decode } from "utils/html-entities";

const tgamMeta = tgamConfig.meta;

/**
 * @method slugify
 * @description Given a headline, create a suitable slug for URLs
 * @param {String} [inUrlHeadline=""] - The headline to slugify
 * @returns {String}
 */
export function slugify(inUrlHeadline = "") {
  return inUrlHeadline.split("-").map(item => {
    return `${item.charAt(0).toUpperCase()}${item.substr(1)}`;
  }).join(" ");
}

/**
 * @method setup
 * @description Initialize the datalayer for stories
 * @returns {Object}
 */
export default function setup() {
  return {
    title: decode(trim(tgamMeta.title.replace(/(- *The Globe And Mail)$/ig, ""))),
    keywords: decode(tgamMeta.keywords),
    seoKeywords: decode(tgamMeta.seoKeywords),
    byline: decode(tgamMeta.byline.toUpperCase()),
    creditline: decode(tgamMeta.creditline || ""),
    contentId: tgamMeta.contentId,
    label: tgamMeta.label,
    topics: decode(tgamMeta.topics || ""),
    pagesubtype: tgamMeta.pagesubtype,
    paywallStatus: tgamMeta.paywallStatus,
    slug: slugify(tgamMeta.slug),
    printArticleFlag: tgamMeta.printArticleFlag,
    isInPrint: tgamMeta.isInPrint,
    advContent: tgamMeta.advContent
  };
}
